import {
  connectFirestoreEmulator,
  Firestore,
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { isProductionEnvironment } from 'shared/utils/is-environment';

import { getAnalytics } from './get-analytics';
import { initApp } from './init-app';

const createDatabase = () => {
  const app = initApp();
  let database;

  try {
    if (!isProductionEnvironment) {
      // eslint-disable-next-line no-console -- dev only
      console.log('[DB] 🟢 Eagerly initializing Firestore...');
    }
    database = initializeFirestore(app, {
      localCache: persistentLocalCache(
        /*settings*/ { tabManager: persistentMultipleTabManager() },
      ),
    });

    if (
      import.meta.env.MODE === 'development' &&
      import.meta.env.VITE_FIREBASE_EMULATOR_URL
    ) {
      connectFirestoreEmulator(
        database,
        import.meta.env.VITE_FIREBASE_EMULATOR_URL,
        8080,
      );
    }

    getAnalytics(app);
    // getPerformanceMonitoring(app);
  } catch (e) {
    if (!isProductionEnvironment) {
      // eslint-disable-next-line no-console -- dev only
      console.warn('[DB] ⚠️ Already initialized. Using existing instance.');
    }
    database = getFirestore(app);
  }

  return database;
};

let db: Firestore | undefined = undefined;

export const getDatabase = () => {
  if (!db) {
    db = createDatabase();
  }

  return db;
};

export const clearDatabase = () => {
  db = undefined;
};
